import {useQuery} from 'react-query'

import {QueryKeyName} from '../../../../DomainsLib/constants'
import {getUserManual} from '../backend/getUserManual'

export function useUserManual(manualFile: string) {
  return useQuery([QueryKeyName.GetUserManual, manualFile], () => getUserManual(manualFile))
}
